declare namespace $ {

	export class $bog_gamengine_demo_crumb_studio extends $bog_gamengine_studio {
		title( ): string
	}
	
}

//# sourceMappingURL=studio.view.tree.d.ts.map